module.exports = __webpack_public_path__ + "img/321.e1531b21.jpg";